import { DateFilter, IdFilter, StringFilter } from "react3l-advanced-filters";
import { ModelFilter } from "react3l-common";

export class LoggingApiFilter extends ModelFilter {
  public id?: IdFilter = new IdFilter();
  public filterType?: IdFilter = new IdFilter();
  public responseStatus?: StringFilter = new StringFilter();
  public requestBody?: StringFilter = new StringFilter();
  public url?: StringFilter = new StringFilter();
  public createdAt?: DateFilter = new DateFilter();
  public constructionModuleId?: any;
}
